import styled from 'styled-components';

export const StyledDeletedCompanies = styled.div`
    padding: 2rem;
`;
